module.exports = __webpack_public_path__ + "img/four-col-grid-icon.abfc2084.svg";